import React,{useState, useEffect} from 'react'
import { useNavigate } from "react-router-dom";
import { useFormContext } from '../../Context/FormContext';

const Step2 = ({setCurrent, current, setCurrentTab, currentTab, key, handleTabChange, navTab, setNavTab,}) => {

  const navigate = useNavigate()

  const { formData, updateFormData,} = useFormContext();

  const [data1, setData1] = useState({one: false, two: false, three: false})

  useEffect(() => {
    if(formData?.checkData){
      setData1(formData?.checkData)
    }
  }, [current]);


  const onSubmit = () => {
      updateFormData({checkData : data1})
      setNavTab(navTab + 1)
      setCurrent(current + 1)
      localStorage.removeItem('navTab')

  }

  
  return (

    <div>

      <div className="tab-pane" id="step2" role="tabpanel" aria-labelledby="nav-step2-tab">
                        
          <div className="agree-dontagree-wrpr">

            <p><strong className="sub-title">STATEMENT FOR REPORTER</strong></p>

            <p>
              This software platform (the Portal) is provided and administered by Shipping Industry Confidential Reporting
              Limited (We/Us). At this stage, we do not have any working relationship with your employer. Before submitting
              your concern, please ensure that you have read and understood the following information.
            </p>
            
            <p><strong className="sub-title">CONFIDENTIAL REPORTING</strong></p>

            <ul>

                <li>
                  The purpose of this Portal is to provide you with an opportunity to submit any concerns you may have
                  securely, confidentially and anonymously to your employer.
                </li>
                
                <li>
                  By reporting any concerns, you are enabling your employer to see individual concerns or 
                  more widespread behaviours and trends and take the appropriate action.
                </li>
                
            </ul>

            <p><strong className="sub-title">WHAT HAPPENS AFTER YOU SUBMIT A CONCERN? </strong></p>

            <ul>

                <li>
                  Once your concern is submitted, your employer will receive an anonymous copy, 
                  which it will consider with a view to resolving to the best of its ability. 
                </li>

                <li>
                  You and your employer will be able (if you so choose) to anonymously communicate directly with
                  each other with a view to finding a resolution.
                </li>

                <li>
                  If your employer is unable to resolve the concern, an ombudsman may be instructed by your employer to
                  assist it in investigating and resolving specific concerns.
                </li>
                
            </ul>

            <p><strong className="sub-title">IS THE PORTAL ANONYMOUS?</strong></p>

            <ul>

                <li>
                  When submitting concerns via the Portal, We do not disclose your identity to your employer. Names and
                  other identifying characteristics submitted in the relevant fields will be automatically stripped before
                  transmitting to your employer and therefore remain confidential to Us.
                </li>

                <li>
                  However, please note that if you disclose personal data concerning yourself or any other persons in the
                  body of your submission, this will be transmitted to your employer to enable them to deal with the specific concern. 
                  Therefore, please ensure that any information you do not wish to be seen by your employer is not disclosed in the main body of your submission.
                </li>

                <li>
                  We confirm that any personal data you disclose to Us will, at all times, be handled in accordance with our
                  Privacy Policy a copy can be found here <button style={{color: '#0088ff', fontWeight: 500, textDecoration: 'underline'}} onClick={() => navigate('/privacy')}>Privacy Policy</button>
                </li>

                <li>
                  Where your employer instructs an ombudsman to assist in the resolution of your concern, your personal
                  data may, with your permission, be passed on to the ombudsman, who will process it in accordance with
                  its individual privacy policy, a copy of which will be provided to you by us prior to your data being
                  transferred.
                </li>
                
            </ul>

            <p><strong className="sub-title">CONFIRMATION STATEMENT (please tick as appropriate)</strong></p>

            <ul className='check-list'>

              <li>
                By submitting this statement, you confirm that:
              </li>

              <br/>


              <li className="reporting-checkbox-wror position-relative">
								<div className="form-check">
									<label className="customcheck">
									
                  <input 
                    type="checkbox"
                    value={data1.one}
                    checked={data1.one}
                    // {...checkboxProps('one')}
                    onChange={(e) => {
                    setData1({one: e.target.checked, two: data1.two, three: data1.three,})}}
                  />

									<span className="checkmark"></span>
									</label>
								</div>

                you have read and understood the information contained in this statement;

						  </li>
              
              <br/>

              <li className="reporting-checkbox-wror position-relative">
								<div className="form-check">
									<label className="customcheck">
									<input 
                    type="checkbox" 
                    // {...checkboxProps('two')}
                    value={data1.two}
                    checked={data1.two}
                    onChange={(e) => 
                      setData1({one: data1.one, two: e.target.checked, three: data1.three,})}
                  />
									<span className="checkmark"></span>
									</label>
								</div>

                the information you are providing in your submission is honest, accurate and unbiased to the best
                of your knowledge and belief; and

						  </li>

              <br/>

              <li className="reporting-checkbox-wror position-relative">
								<div className="form-check">
									<label className="customcheck">
									<input 
                    type="checkbox"
                    // {...checkboxProps('three')}
                    value={data1.three}
                    checked={data1.three}
                    onChange={(e) => 
                      setData1({one: data1.one, two: data1.two, three: e.target.checked})}
                  />
									<span className="checkmark"></span>
									</label>
								</div>

                you understand that if you knowingly or recklessly submit information which is proven to be
                dishonest or manifestly inaccurate, further action may be taken against you.

						  </li>

            </ul>
          
          </div>

          <div className="agreen-btn-wrpr  text-center mt-5">

            <button 
              className="btn btn-primary btn-agree gotoStp1" 
              onClick={() => {
                setNavTab(navTab - 1)
                localStorage.removeItem('navTab')
                setCurrent(current - 1)
              }}
                
            >
                I Don't Agree <i className="icon-close"></i>
            </button>

            <button 
              type='submit' 
              className="btn btn-primary btn-agree gotoStp3" 

              disabled={data1.one && data1.two && data1.three ? false : true}
              onClick={onSubmit}
            >
                I Agree <i className="icon-arrow-right1"></i>
            </button>

          </div>

      </div>

    </div>

  )
}

export default Step2